import * as yup from 'yup'

export const validateUpdateProductCharacteristics = yup.object().shape({
    name: yup
    .string()
    .min(3, 'El NOMBRE debe tener más de 2 caracteres'),
})